import { useFormContext } from 'react-hook-form';

import { Button } from '@nesso/ui/primitives/button';
import { FormControl, FormField, FormItem } from '@nesso/ui/primitives/form';

import { MAX_SELECTED_APPROACHES } from '@/entities/session';
import type { GenerateNote } from '@/entities/session-note';
import {
    treatmentApproachesGroupsOrder,
    useTreatmentApproachesOptions,
} from '@/entities/treatment-approach';
import { InlineMultiSelect } from '@/shared/ui/common/inline-multi-select';

type Props = {
    onSubmit: (data: GenerateNote) => void;
    onCancel: () => void;
};

export function EditTreatmentApproachesContentDialogForm({ onSubmit, onCancel }: Props) {
    const { handleSubmit, control } = useFormContext<GenerateNote>();
    const options = useTreatmentApproachesOptions();

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col flex-1 overflow-hidden">
            <FormField
                control={control}
                name="treatmentApproaches"
                render={({ field }) => (
                    <FormItem className="flex flex-col flex-1 overflow-hidden">
                        <FormControl>
                            <InlineMultiSelect
                                options={options}
                                groupOrder={treatmentApproachesGroupsOrder}
                                selected={field.value}
                                onChange={field.onChange}
                                maxSelected={MAX_SELECTED_APPROACHES}
                            />
                        </FormControl>
                    </FormItem>
                )}
            />

            <div className="flex flex-row gap-2 p-6">
                <Button type="button" variant="outline" className="flex-1" onClick={onCancel}>
                    Cancel
                </Button>
                <Button type="submit" className="flex-1">
                    Update
                </Button>
            </div>
        </form>
    );
}
